import React from "react";
import NoInternet from "../icons/NoInternet.svg";
import RefreshIcon from "../icons/RotateCW16.svg";
import { LuxEmptyState } from "@lux/atoms/components/LuxEmptyState";
import { LuxButton } from "@lux/atoms/components/LuxButton";

export const GlowErrorState = ({
  onRetry,
  ...props
}: Partial<
  Omit<
    React.ComponentPropsWithoutRef<typeof LuxEmptyState>,
    "cta" | "iconStyle"
  >
> & {
  onRetry: () => unknown;
}) => {
  return (
    <LuxEmptyState
      desc="There was an issue loading this content. Please check your connection and try again."
      title="Network Error"
      icon={<NoInternet />}
      {...props}
      cta={
        <LuxButton
          label="Retry"
          onClick={onRetry}
          icon={<RefreshIcon />}
          rounded
          color="light"
        />
      }
    />
  );
};
